<!--  -->
<template>
  <div class="indentPice">
    <div>
      <span class="title">总计</span>
      <span class="pice">￥{{orderDetail.orderTotalAmount}}</span>
    </div>
    <div v-if="
      orderDetail.singleDiscountAmount &&
      orderDetail.paymentType !=7 &&
      Number(orderDetail.singleDiscountAmount) > 0">
      <span class="title">促销优惠</span>
      <span class="pice">-￥{{orderDetail.singleDiscountAmount}}</span>
    </div>
    <div v-if="
    orderDetail.unionDiscounAmount &&
    orderDetail.paymentType !=7 &&
    Number(orderDetail.unionDiscounAmount) > 0">
      <span class="title">联报优惠</span>
      <span class="pice">-￥{{orderDetail.unionDiscounAmount}}</span>
    </div>
    <div v-if="orderDetail.paymentType !=7 && fullReductionAmount > 0">
      <span class="title">满减优惠</span>
      <span class="pice">-￥{{fullReductionAmount}}</span>
    </div>
    <div v-if="
      orderDetail.bargainDiscountAmount &&
      orderDetail.paymentType !=7 &&
      Number(orderDetail.bargainDiscountAmount) > 0">
      <span class="title">砍价优惠</span>
      <span class="pice">-￥{{orderDetail.bargainDiscountAmount}}</span>
    </div>
    <div v-if="
      orderDetail.couponDiscountAmount &&
      orderDetail.paymentType !=7 &&
      Number(orderDetail.couponDiscountAmount) > 0">
      <span class="title">优惠券</span>
      <span class="pice">-￥{{orderDetail.couponDiscountAmount}}</span>
    </div>
     <div v-if="
      orderDetail.deductionDiscountAmount &&
      orderDetail.paymentType !=7&&
      Number(orderDetail.deductionDiscountAmount) > 0">
      <span class="title">抵扣码</span>
      <span class="pice">-￥{{orderDetail.deductionDiscountAmount}}</span>
    </div>
    <div>
      <span class="title">{{selectPayText(orderDetail.status)}}</span>
      <span class="pay">￥{{orderDetail.channelMark==45?0:orderDetail.partnerOrder?orderDetail.orderTotalAmount:orderDetail.orderAmount}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderDetail: {
      type: Object,
    },
  },
  computed: {
    fullReductionAmount() {
      return (
        (Number(this.orderDetail.fullDiscountAmount) || 0) +
        (Number(this.orderDetail.fullPackageDiscountAmount) || 0)
      );
    },
    selectPayText() {
      return (data) => {
        switch (data) {
          case 3:
            return '实付';
          default:
            return '应付';
        }
      };
    },
  },
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};

</script>
<style lang="scss" scoped>
.indentPice{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  // height: 234px;
  margin-bottom: 22px;
  padding:29px 36px 4px;
  background: $bgWhite;
  border-radius: 14px;
  div{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 29px;
    color: $fontColorBlack;
    font-size: 25px;
  }
  .title{
    font-weight: 500;
    line-height: 36px;
  }
  .pice{
    font-weight: 400;
    line-height: 29px;
  }
  .pay{
    color: $theme_color;
    font-size: 33px;
    line-height: 45px;
  }
}
</style>
